const widget = document.querySelector(".contact-widget");

if (widget) {
  const updateVisibility = () => {
    widget.classList.toggle(
      "is-visible",
      window.scrollY >= window.innerHeight,
    );
  };

  window.addEventListener("scroll", updateVisibility, { passive: true });
  window.addEventListener("resize", updateVisibility, { passive: true });
  updateVisibility();
}
